import { createApp } from 'vue'
import DrawBox from '../components/DrawBox.vue'

export function initDrawBox() {
  const node = document.querySelector('#draw-box')
  if(node == null) return

  const areaX1 = parseInt(node.dataset.areaX1)
  const areaY1 = parseInt(node.dataset.areaY1)
  const areaX2 = parseInt(node.dataset.areaX2)
  const areaY2 = parseInt(node.dataset.areaY2)
  const areaX3 = parseInt(node.dataset.areaX3)
  const areaY3 = parseInt(node.dataset.areaY3)
  const areaX4 = parseInt(node.dataset.areaX4)
  const areaY4 = parseInt(node.dataset.areaY4)
  const sensorId = parseInt(node.dataset.sensorId)
  const modelName = node.dataset.modelName
  const app = createApp(DrawBox, {
    areaX1: areaX1,
    areaY1: areaY1,
    areaX2: areaX2,
    areaY2: areaY2,
    areaX3: areaX3,
    areaY3: areaY3,
    areaX4: areaX4,
    areaY4: areaY4,
    sensorId: sensorId,
    modelName: modelName,
  })

  app.mount('#draw-box')
}
